// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles for EmojiVerificationScreen component
 * Reusable component for any verification type
 */

.emoji-verification-screen {
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: roboto, sans-serif;
}

.emoji-verification-content {
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Instructions */
.emoji-verification-instructions {
  margin-bottom: 30px;
  font-size: 16px;
  color: #666;
  text-align: center;
  line-height: 1.5;
}

/* Emoji Grid */
.emoji-verification-emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
  width: 100%;
  margin-bottom: 30px;
}

.emoji-verification-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  padding: 10px;
  background: #FCFCFE;
  border-radius: 15px;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.emoji-verification-item:hover {
  background: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.emoji-verification-icon {
  font-size: 50px;
  margin-bottom: 10px;
  line-height: 1;
  user-select: none;
}

.emoji-verification-name {
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  color: #4A4A4A;
  text-align: center;
  font-weight: 600;
  line-height: 1.36;
}

/* Actions */
.emoji-verification-actions {
  display: flex;
  gap: 12px;
  width: 100%;
  max-width: 400px;
  padding: 0 10px;
}

.emoji-verification-actions .btn {
  flex: 1;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.emoji-verification-reject {
  background: rgba(216, 216, 216, 1);
  color: rgba(106, 106, 106, 1);;
  border: none;
}

.emoji-verification-reject:hover:not(:disabled) {
  background: rgba(186, 186, 186, 1);
  box-shadow: 0 2px 8px rgba(106, 106, 106, 0.3);
}

.emoji-verification-confirm {
  background: var(--netsfere-red);
  color: white;
  border: none;
}

.emoji-verification-confirm:hover:not(:disabled) {
  background: rgb(192, 52, 68);
  box-shadow: 0 2px 8px rgba(222, 72, 88, 0.3);
}

.emoji-verification-actions .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Waiting State */
.emoji-verification-waiting {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
}

.emoji-verification-waiting .spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f0f0f0;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.emoji-verification-waiting p {
  font-size: 16px;
  color: #666;
  margin: 0;
}

/* Error State */
.emoji-verification-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
}

.emoji-verification-error p {
  font-size: 16px;
  color: #dc3545;
  margin: 0;
}

/* Spinner animation */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Responsive adjustments */
@media (max-width: 550px) {
  .emoji-verification-emojis {
    gap: 16px;
  }

  .emoji-verification-item {
    width: 100px;
    height: 100px;
    padding: 8px;
  }

  .emoji-verification-icon {
    font-size: 40px;
  }

  .emoji-verification-name {
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  .emoji-verification-emojis {
    gap: 12px;
  }

  .emoji-verification-item {
    width: 90px;
    height: 90px;
  }

  .emoji-verification-icon {
    font-size: 32px;
  }

  .emoji-verification-name {
    font-size: 12px;
  }

  .emoji-verification-actions {
    flex-direction: column;
  }

  .emoji-verification-actions .btn {
    width: 100%;
  }
}

/* Dark theme support */
@media (prefers-color-scheme: dark) {
  .emoji-verification-instructions {
    color: #b0b0b0;
  }

  .emoji-verification-item {
    background: #2a2a2a;
  }

  .emoji-verification-item:hover {
    background: #3a3a3a;
  }

  .emoji-verification-name {
    color: #b0b0b0;
  }

  .emoji-verification-waiting p,
  .emoji-verification-error p {
    color: #b0b0b0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/verification/EmojiVerificationScreen.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;AACF","sourcesContent":["/**\n * Styles for EmojiVerificationScreen component\n * Reusable component for any verification type\n */\n\n.emoji-verification-screen {\n  width: 100%;\n  min-height: 300px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-family: roboto, sans-serif;\n}\n\n.emoji-verification-content {\n  width: 100%;\n  max-width: 560px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Instructions */\n.emoji-verification-instructions {\n  margin-bottom: 30px;\n  font-size: 16px;\n  color: #666;\n  text-align: center;\n  line-height: 1.5;\n}\n\n/* Emoji Grid */\n.emoji-verification-emojis {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 24px;\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.emoji-verification-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 120px;\n  height: 120px;\n  padding: 10px;\n  background: #FCFCFE;\n  border-radius: 15px;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.emoji-verification-item:hover {\n  background: #e9ecef;\n  transform: translateY(-2px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.emoji-verification-icon {\n  font-size: 50px;\n  margin-bottom: 10px;\n  line-height: 1;\n  user-select: none;\n}\n\n.emoji-verification-name {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  color: #4A4A4A;\n  text-align: center;\n  font-weight: 600;\n  line-height: 1.36;\n}\n\n/* Actions */\n.emoji-verification-actions {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  max-width: 400px;\n  padding: 0 10px;\n}\n\n.emoji-verification-actions .btn {\n  flex: 1;\n  padding: 12px 24px;\n  font-size: 15px;\n  font-weight: 600;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.emoji-verification-reject {\n  background: rgba(216, 216, 216, 1);\n  color: rgba(106, 106, 106, 1);;\n  border: none;\n}\n\n.emoji-verification-reject:hover:not(:disabled) {\n  background: rgba(186, 186, 186, 1);\n  box-shadow: 0 2px 8px rgba(106, 106, 106, 0.3);\n}\n\n.emoji-verification-confirm {\n  background: var(--netsfere-red);\n  color: white;\n  border: none;\n}\n\n.emoji-verification-confirm:hover:not(:disabled) {\n  background: rgb(192, 52, 68);\n  box-shadow: 0 2px 8px rgba(222, 72, 88, 0.3);\n}\n\n.emoji-verification-actions .btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Waiting State */\n.emoji-verification-waiting {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.emoji-verification-waiting .spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #f0f0f0;\n  border-top: 3px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n.emoji-verification-waiting p {\n  font-size: 16px;\n  color: #666;\n  margin: 0;\n}\n\n/* Error State */\n.emoji-verification-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.emoji-verification-error p {\n  font-size: 16px;\n  color: #dc3545;\n  margin: 0;\n}\n\n/* Spinner animation */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 550px) {\n  .emoji-verification-emojis {\n    gap: 16px;\n  }\n\n  .emoji-verification-item {\n    width: 100px;\n    height: 100px;\n    padding: 8px;\n  }\n\n  .emoji-verification-icon {\n    font-size: 40px;\n  }\n\n  .emoji-verification-name {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 400px) {\n  .emoji-verification-emojis {\n    gap: 12px;\n  }\n\n  .emoji-verification-item {\n    width: 90px;\n    height: 90px;\n  }\n\n  .emoji-verification-icon {\n    font-size: 32px;\n  }\n\n  .emoji-verification-name {\n    font-size: 12px;\n  }\n\n  .emoji-verification-actions {\n    flex-direction: column;\n  }\n\n  .emoji-verification-actions .btn {\n    width: 100%;\n  }\n}\n\n/* Dark theme support */\n@media (prefers-color-scheme: dark) {\n  .emoji-verification-instructions {\n    color: #b0b0b0;\n  }\n\n  .emoji-verification-item {\n    background: #2a2a2a;\n  }\n\n  .emoji-verification-item:hover {\n    background: #3a3a3a;\n  }\n\n  .emoji-verification-name {\n    color: #b0b0b0;\n  }\n\n  .emoji-verification-waiting p,\n  .emoji-verification-error p {\n    color: #b0b0b0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
